// extracted by mini-css-extract-plugin
export default {"root":"FilteringResultsPlaceholder_root__OHOtZ"};